import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

const DEFAULT_ROW_COUNT = 3;
const MOBILE_QUICK_COLUMN_COUNT = 3;
const DESKTOP_QUICK_COLUMN_COUNT = 7;

@Component({
  selector: 'app-tournament-group-skeleton',
  standalone: true,
  templateUrl: './tournament-group-skeleton.component.html',
  styleUrl: './tournament-group-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TournamentGroupSkeletonComponent {
  readonly rowCount = input(DEFAULT_ROW_COUNT);
  readonly mobile = input(false);
  protected readonly quickColumnIndexes = computed(() => {
    const count = this.mobile() ? MOBILE_QUICK_COLUMN_COUNT : DESKTOP_QUICK_COLUMN_COUNT;
    return Array.from({ length: count }, (_, index) => index);
  });
  protected readonly rowIndexes = computed(() => Array.from({ length: this.rowCount() }, (_, index) => index));
}
